export default __webpack_public_path__ + "static/media/56ca43f718144089be9414411bbf51d1.4b19286c.png";